<template>
  <v-container
    id="view-credit-billing-list"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <h2>All Credit Billing Developments</h2>

      </v-col>

      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="developments"
          item-key="name"
          no-data-text="No active developments available. Please contact support"
          class="elevation-1"
        >
          <template #item.name="{ value }">
            <span>{{ value }}</span>

          </template>
          <template #item.external_bills="{ value }">
            <v-chip
              color="#FF4136"
              dark
              small
              v-if="value > 0"
            >
              Approvals Pending
            </v-chip>
          </template>
          <template #item.starts="{ value }">
            <span>{{ formatterDate(value) }}</span>
          </template>
          <template #item.is_active="{ value }">
            <v-icon
              class="active-check"
              v-if="value"
              right
            >
              mdi-check-circle
            </v-icon>
            <v-icon
              class="active-times"
              v-else
              right
            >
              mdi-close-circle
            </v-icon>
          </template>
          <template #item.missing="{ value, item }">
            <v-chip
              color="#FF4136"
              dark
              v-if="value"
            >
              {{ value }} / {{ item.meters }}
            </v-chip>
          </template>
          <template #item.id="{ value }">

            <router-link
              custom v-slot="{ navigate }"
              :to="`/credit-billing/${value}`"
            >
              <button @click="navigate" role="link">
                <v-icon
                  right
                >
                  mdi-arrow-right-bold
                </v-icon>
              </button>
            </router-link
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get } from 'vuex-pathify';
import { date } from "@/mixins/date";

export default {
  name: "CreditBillingList",
  metaInfo () {
    return {
      title: "Credit Billing"
    }
  },
  mixins: [date],
  computed: {
    developments: get('creditBilling/developments')
  },
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  data: function () {
    return {
      loaded: false,
      headers: [
        {
          text: 'Development Name',
          align: 'start',
          value: 'name',
        },
        {text: 'Notifications', value: 'external_bills'},
        {text: 'Available from', value: 'starts'},
        {text: 'Company', value: 'company_name'},
        {text: 'Active', value: 'is_active'},
        {text: 'Buildings', value: 'buildings'},
        {text: 'Apartments', value: 'apartments'},
        {text: '', value: 'id'},
      ],
    }
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", { title: "Loading Development List" });

      if (!this.developments.length) {
        await this.$store.dispatch("creditBilling/getDevelopmentList");
      }

      await this.$store.dispatch("loader/loaderCancel");

      this.loaded = true;
    },
    formatterDate(value) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, false);
    }
  }
}
</script>

<style lang="scss" scoped>
.active-check {
  color: darkgreen;
}

.active-times {
  color: darkred;
}
</style>
